import { Link } from "react-router-dom";

export const morningSuggestions = (
  <div>
    ✔ 20-30-50хв 🇺🇸 Туплю вивчаючи англійську (або не туплю) <br />
    ✔ 1.5хв П'ю водичку <br />
    ✔ 15хв Ванні процедури і лице крем <br />
    ✔ 2хв Пишу Ангеліні (Але ігнорую все інше в тг) "Добрий Ранок!" <br />
    ✔ 10хв Згадую плани <br />
    ✔ 3хв Провітрюю кімнату <br />
    ✔ 5хв Важусь з підключенням до yunmai <br />
    ✔ 5хв Застеляю ліжко <br />
    <Link to="food">✔ 10хв 🥬 Заплановую харчування</Link> <br />
    <Link to="/pray_morning">✔ 15хв Читаю 2-3 молитви</Link> <br />
    <Link to="/habits">✔ 10хв Перечитую рекомендовані звички</Link> <br />
  </div>
);
export const eveningSuggestions = (
  <div>
    <Link to="day_report">✔ 25хв Заповнюю анкету за день</Link> <br />
    ✔ 25хв План дня: Accumulative -&gt; Anniversaries -&gt; People Relationships{" "}
    <br />
    ✔ 10хв План дня: Розкладаю по поличках <br />
    <Link to="/pray_evening">✔ Читаю 2-3 молитви</Link> <br />
    ✔ 15хв Умиваюсь і лице крем <br />
    ✔ 15хв Бажаю Ангеліні доброї ночі <br />
    ✔ 5хв Провітрюю кімнату <br />
    ✔ 1.5хв П'ю водичку <br />
    ✔ 5хв Упевняюсь в увімкненості лампочок <br />
    ✔ 2хв Наводжу будильник <br />
    ✔ Іду спати <br />
  </div>
);
